webpackJsonp([269829036549620],{

/***/ 312:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(312);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this is a landing for the multiple other services
	function pageHeight() {
	  return document.querySelector('body').getBoundingClientRect().height;
	}
	
	var ServicesPage = function ServicesPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Services | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default, alt: 'turf maintenance project' })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Services'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We offer a wide range of custom solutions.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'servWrap' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'We provide a wide range of services'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          ' After 20 years of experience, ICE offers a wide range of solutions to accomplish projects of every size. If your service isn\'t listed, ',
	          _react2.default.createElement(
	            'span',
	            { onClick: function onClick() {
	                return window.scrollTo({ top: pageHeight(), behavior: 'smooth' });
	              } },
	            'contact'
	          ),
	          ' us today for a custom solution.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'service' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Landscape Maintenance ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'Including mulching, irrigation, aeration'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/landscape-maintenance' },
	            'Learn about landscape maintenance \u2192'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'service' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Turf Fertilization ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'the number 1 sports field care specialists'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/turf-fertilization' },
	            'Learn about turf fertilization \u2192'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'service' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Weed Control ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'control and prevention of weeds'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/weed-control' },
	            'Learn about weed control \u2192'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'service' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Retaining Walls & Patio\'s ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'architecture & soil retention'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/retaining-walls+patios' },
	            'Learn about retaining walls \u2192'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'service' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Snow Removal & Salting ',
	            _react2.default.createElement(
	              'span',
	              null,
	              'snow removal, relocation, and deIcing'
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/services/snow-removal' },
	            'Learn about snow removal \u2192'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = ServicesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-ecfccd6d8f863efbe941.js